import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { Box } from "@mui/material";
import { FC } from "react";

interface IWCBAllProvincesCodeSetupInfoFieldsPanel {
	codesDDL:any[];
 }
export const WCBAllProvincesCodeSetupInfoFieldsPanel: FC<
	IWCBAllProvincesCodeSetupInfoFieldsPanel
> = ({ codesDDL }) => {
	return (
		<Box>
			<EnhancedDropDownRHFWithLabel
				testId={"code-setup"}
				selectName={"code"}
				items={codesDDL ?? []}
				label={"Select Code"}
				showEmpty
			/>
		</Box>
	);
};
